import { render, staticRenderFns } from "./ManuscriptFolderList.vue?vue&type=template&id=072f6960&scoped=true"
import script from "./ManuscriptFolderList.vue?vue&type=script&lang=ts"
export * from "./ManuscriptFolderList.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptFolderList.vue?vue&type=style&index=0&id=072f6960&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072f6960",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072f6960')) {
      api.createRecord('072f6960', component.options)
    } else {
      api.reload('072f6960', component.options)
    }
    module.hot.accept("./ManuscriptFolderList.vue?vue&type=template&id=072f6960&scoped=true", function () {
      api.rerender('072f6960', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/ManuscriptFolderList.vue"
export default component.exports